import React from 'react';

import Box from '@mui/material/Box';

import { IoTrophy } from '@react-icons/all-files/io5/IoTrophy';
import { ICellRenderProps, IWithTrophy } from './interface';

export const withTrophy = (Component: React.FC<ICellRenderProps>) => {
  return ({ showTrophy, ...props }: IWithTrophy) => {
    if (!showTrophy) return <Component {...props} />;

    return (
      <Box
        display="flex"
        alignItems="center"
        gap={0.5}
        justifyContent="flex-end"
      >
        <IoTrophy size={13} color="#CCAC00" />
        <Component {...props} />
      </Box>
    );
  };
};
